"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDraggable = void 0;
const React = __importStar(require("react"));
const useRef_1 = require("./useRef");
function useDraggable(events) {
    const [ref] = useRef_1.useRef();
    events = events || {};
    const [state, setState] = React.useState({
        coords: { x: 0, y: 0 },
        bDrag: false,
        time: 0,
    });
    const onDocumentMouseDown = React.useCallback(({ target, clientX, clientY }) => {
        const drag = target === (ref === null || ref === void 0 ? void 0 : ref.current);
        if (drag && drag != state.bDrag) {
            setState({ coords: { x: clientX, y: clientY }, bDrag: true, time: performance.now() });
            events.onDragStart && events.onDragStart();
        }
        if (!drag)
            events.onNotDrag && events.onNotDrag();
    }, [ref.current, state.bDrag, events.onNotDrag]);
    const onDocumentMouseUp = React.useCallback(({ clientX, clientY }) => {
        if (state.bDrag) {
            const drag_time = performance.now() - state.time;
            const coords = { x: clientX - state.coords.x, y: clientY - state.coords.y };
            if (drag_time < 300 && coords.x == 0 && coords.y == 0)
                events.onClick && events.onClick({ x: clientX, y: clientY });
            setState({ coords, bDrag: false, time: 0 });
            events.onDragEnd && events.onDragEnd(coords, { x: clientX, y: clientY }, drag_time);
        }
    }, [ref.current, state.bDrag]);
    const onDocumentMouseMove = React.useCallback(({ clientX, clientY }) => {
        if (state.bDrag) {
            const coords = { x: clientX - state.coords.x, y: clientY - state.coords.y };
            setState({ coords, bDrag: true, time: 0 });
            events.onDrag && events.onDrag(coords, { x: clientX, y: clientY });
        }
    }, [ref.current, state.bDrag]);
    React.useEffect(() => {
        document.addEventListener('mousedown', onDocumentMouseDown, { passive: true });
        document.addEventListener('mouseup', onDocumentMouseUp, { passive: true });
        document.addEventListener('mousemove', onDocumentMouseMove, { passive: true });
        return () => {
            document.removeEventListener('mousedown', onDocumentMouseDown);
            document.removeEventListener('mouseup', onDocumentMouseUp);
            document.removeEventListener('mousemove', onDocumentMouseMove);
        };
    }, [ref.current, onDocumentMouseDown, onDocumentMouseMove, onDocumentMouseUp]);
    return ref;
}
exports.useDraggable = useDraggable;
